import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-legal-modal',
  standalone: true,
  imports: [FontAwesomeModule],
  templateUrl: './legal-modal.component.html',
})
export class LegalModalComponent {
  @Input() title = 'Condiciones de servicio';
  @Output() close = new EventEmitter<void>();

  faTimes = faTimes;
}
